<template>
  <div
    v-if="computedHasMoisture"
    class="moisture-component"
  >
    <ul class="moisture-component__list">
      <li
        v-for="(item, index) in moisture.list"
        :key="index"
        class="moisture-component__list__item"
      >
        <div
          class="moisture-component__list__item__content"
          :class="['moisture-component__list__item__content--' + returnFillColor(item.state)]"
          @click="moistureListItemClick(item)"
        >
          <font-awesome-icon
            v-if="isInThePast(item.timestamp)"
            :icon="['far', 'clock']"
            :title="'Data is more than one hour old'"
            class="moisture-component__list__item__old-data"
          />
          <div class="moisture-component__list__item__name">
            {{ item.type === 'Sensor' ? $tc('messages.sharedTexts.program', 1) : '???' }} {{ item.id }}
          </div>
          <div class="moisture-component__list__item__date-time">
            {{ getDateTime(item.timestamp) }}
          </div>
          <div
            class="moisture-component__list__item__moisture"
            :title="`${item.value}%`"
          >
            {{ Math.round(item.value) }}%
          </div>
          <div
            class="moisture-component__list__item__depth"
            :title="item.depth + computedSign"
          >
            {{ Math.round(item.depth) }}{{ computedSign }}
          </div>
        </div>
        <div
          class="moisture-component__list__item__fill"
          :style="{top: (100 - item.value) + '%'}"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default
{
  name: 'MoistureComponent',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props:
  {
    moisture: {
      type: Object,
      default() {
        return {
          measurementType: 'imperial',
          list: [{
            id: 1,
            value: 25,
            state: 5,
            timestamp: 1549890003000,
            depth: 3,
            type: 'Sensor'
          }]
        }
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedHasMoisture() {
      return this.moisture && this.moisture.list && this.moisture.list.length
    },
    computedSign() {
      return this.moisture.measurementType === 'metric' ? 'cm' : '"'
    }
  },
  methods: {
    isInThePast(time) {
      return this.store.getData('controller.time') - 3600 > time
    },
    getDateTime(timestamp) {
      const format = this.store.getData('settings.time.use12HourClock') ? 'M/D/YY h:mmA' : 'D/M/YY h:mm'
      return moment(parseInt(timestamp, 10)).utc().format(format)
    },
    moistureListItemClick(item) {
      // this.$router.push('/sensors?name=' + item.id)
    },
    returnFillColor(state) {
      const states = {
        1: 'grey',
        2: 'red',
        3: 'yellow',
        4: 'green',
        5: 'blue'
      }

      return states[state]
    }
  }
}
</script>

<style lang="scss">
  .moisture-component {
    &__list {
      display: grid;
      grid-gap: $application-base-padding * 2;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      &__item {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        border: 4px solid $color-grey;
        border-radius: $application-base-border-radius * 2;
        background-color: $color-white;
        overflow: hidden;
        cursor: pointer;
        $color: darken($color-grey-dark, 10);

        &__old-data {
          position: absolute;
          top: 0;
          right: 0;
          transform: translate3d(50%, -50%, 0);
          color: darken($color-green, 30);
          background: $color-white;
          border-radius: 50%;
          cursor: help;
        }

        &__date-time {
          font-size: 11px;
          color: $color-black;
          padding: 3px 0;
          text-align: center;
          white-space: nowrap;
        }

        &__fill {
          position: absolute;
          bottom: 0;
          right: 0;
          left: 0;
          background: linear-gradient(180deg, lighten($color-blue-marine,10) 0%,rgba($color-blue-marine, 1) 100%);

          transition: all 0.4s;
        }

        &__content {
          $padding: $application-base-padding * 2;
          padding: $padding / 2;
          position: absolute;
          top: $padding;
          right: $padding;
          bottom: $padding;
          left: $padding;

          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(180deg, lighten($color-grey-dark,10) 0%, $color-grey-darker 100%);
          border: 2px solid darken($color-green, 30);
          border-radius: $application-base-border-radius;

          color: $color-white;

          z-index: 2;

          transition: all 0.4s;

          &--grey {
           background: linear-gradient(180deg, lighten($color-grey,10) 0%, darken($color-grey, 10) 100%);
          }
          &--blue {
           background: linear-gradient(180deg, lighten($color-blue-marine,10) 0%, darken($color-blue-marine, 10) 100%);
          }
          &--red {
            background: linear-gradient(180deg, lighten($color-red,10) 0%, darken($color-red, 10) 100%);
          }
          &--yellow {
            background: linear-gradient(180deg, lighten($color-orange,10) 0%, darken($color-orange, 10) 100%);
          }
          &--green {
            background: linear-gradient(180deg, lighten($color-green-grass, 5) 0%, darken($color-green-grass, 10) 100%);
          }
        }

        &__name {
          font-family: $font-primary-medium;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          flex-shrink: 0;
        }
        &__moisture {
          font-family: $font-primary-semibold;
          font-size: 26px;
        }
        &__depth {
          font-family: $font-primary-semibold;
          font-size: 23px;
        }
      }
    }
  }
</style>
